var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"rounded-lg pa-0",attrs:{"color":"secondaryAction","height":"4em"},on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("mdi-chevron-left")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }